<template>
  <div v-if="modalOpenState">
    <div class="modal-backdrop"></div>
    <div
      :class="{ 'p-2 p-sm-3': !isFullMobile }"
      @click="close"
      class="overlay p-sm-3 d-sm-flex justify-content-center align-items-center"
    >
      <div
        :class="{ fullscreen: isFullMobile }"
        :style="computedSize"
        @click.stop
        class="info p-2 p-sm-3 shadow overflow-auto"
      >
        <div v-if="title" class="modal-title">
          <div class="h4 mb-0 flex-grow-1 text-left">{{ title }}</div>
          <div class="ml-auto m-n2 m-sm-n3 ">
            <button
              @click="() => hideModal(identifier)"
              class="btn btn-reset p-0 float-right text-lg p-2 p-sm-3"
            >
              <Close class="svg-fill-dark svg-24" />
            </button>
          </div>
        </div>
        <slot :close="() => hideModal(identifier)"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import Close from "../../icons/atalanda/close.svg";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "Modal",
  components: {
    Close,
  },
  props: {
    identifier: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      required: false,
      default: "",
    },
    initialOpen: {
      type: Boolean,
      required: false,
      default: false,
    },
    closeOnOutsideClick: {
      type: Boolean,
      required: false,
      default: true,
    },
    isFullMobile: {
      type: Boolean,
      required: false,
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
  },
  computed: {
    ...mapGetters({
      openModals: "getOpenModals",
    }),
    modalOpenState() {
      return this.openModals.includes(this.identifier);
    },
    computedSize() {
      let returnedSize;
      switch (this.size) {
        case "sm":
          returnedSize = 400;
          break;
        case "md":
          returnedSize = 800;
          break;
        case "lg":
          returnedSize = 1200;
          break;
      }
      return this.size ? `max-width: ${returnedSize}px` : "";
    },
  },
  mounted() {
    if (this.initialOpen) this.showModal(this.identifier);
  },
  methods: {
    ...mapActions(["showModal", "hideModal"]),
    close() {
      if (this.closeOnOutsideClick) this.hideModal(this.identifier);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.overlay {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: $zi-highest;
  top: 0;
  left: 0;
}

.modal-backdrop {
  background: rgba($gray-900, 0.3);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: $zi-highest;
}

.info {
  width: 100%;
  background: $white;
  max-width: auto;
  display: flex;
  flex-direction: column;
  height: auto;
  max-height: 100%;
  border-radius: $border-radius-lg;

  @media (min-width: $screen-sm-min) {
    max-width: $screen-sm-min;
  }
}

.modal-title {
  display: flex;
  justify-content: space-between;
  border-bottom: $width-border-thin solid $gray-300;
  margin: -$spacer-2;
  margin-top: 0;
  margin-bottom: $spacer-2;
  padding: $spacer-2;
  padding-top: 0;
  padding-bottom: $spacer-2;

  @media (min-width: $screen-sm-min) {
    margin: -$spacer-3;
    margin-bottom: $spacer-3;
    padding: $spacer-3;
    padding-bottom: $spacer-3;
  }
}

.fullsize {
  max-width: 100%;
}

.fullscreen {
  height: 100%;
  border-radius: 0;

  @media (min-width: $screen-sm-min) {
    height: auto;
    max-height: 100%;
    border-radius: $border-radius-lg;
  }
}
</style>
